function pointIssueRules(app) {
  return {
    //
    pointIssue: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.companyWalletPointDist.pointIssue')
        })
      },
      {
        max: 10,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.companyWalletPointDist.pointIssue'),
          length: 10
        })
      },
      {
        // pattern: /^[0-9]*[1-9][0-9]*$/,
        pattern: /^[0-9]*$/,
        trigger: 'change',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.companyWalletPointDist.pointIssue'),
          type: '半角数字'
        })
      },
      {
        pattern: /^[0-9]{1}[0-9]*$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.pointIsson')
      },

    ]
  }
}

export default {
  pointIssueRules: pointIssueRules
}
